import {
  DeleteCustomTimeRangeCategoryDocument,
  DeleteCustomTimeRangeCategoryMutationVariables,
  GetCustomTimeRangeCategoriesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteCustomTimeRangeCategory = () => {
  const [deleteCustomTimeRangeCategory, { loading }] = useMutation(
    DeleteCustomTimeRangeCategoryDocument,
    {
      extractorFn: (data) => data.attendanceMutations.deleteAttendanceCustomTimeRangeCategory,
    }
  )

  const deleteCategory = (variables: DeleteCustomTimeRangeCategoryMutationVariables) => {
    return deleteCustomTimeRangeCategory({
      variables,
      refetchQueries: [GetCustomTimeRangeCategoriesDocument],
    })
  }

  return {
    loading,
    deleteCategory,
  }
}
